import Cesium from "../../../../MapStore2/web/client/libs/cesium";

export const getPolylinePositionWithHeight = (positions: any, height: any) => {
    const point1InRadians = Cesium.Cartographic.fromCartesian(positions.getValue()[0]);
    const point2InRadians = Cesium.Cartographic.fromCartesian(positions.getValue()[1]);

    return Cesium.Cartesian3.fromRadiansArrayHeights([
        point1InRadians.longitude,
        point1InRadians.latitude,
        height,
        point2InRadians.longitude,
        point2InRadians.latitude,
        height,
    ]);
};

export const transformPointPositionToVerticalPolylinePositions = (position: any, lowerLimit: any, upperLimit: any) => {
    const positionInRadians = Cesium.Cartographic.fromCartesian(position.getValue());
    return Cesium.Cartesian3.fromRadiansArrayHeights([
        positionInRadians.longitude,
        positionInRadians.latitude,
        lowerLimit,
        positionInRadians.longitude,
        positionInRadians.latitude,
        upperLimit,
    ]);
}
